export default "__VITE_ASSET__BYQU83Rn__"